import { render, staticRenderFns } from "./MyAccreditationPassForm.vue?vue&type=template&id=1abac719&scoped=true"
import script from "./MyAccreditationPassForm.vue?vue&type=script&lang=js"
export * from "./MyAccreditationPassForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1abac719",
  null
  
)

export default component.exports